// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { crmManifest } from './crm';
import { governmentManifest } from './government';
import { governmentRelationsManifest } from './government-relations';
import { surveysManifest } from './surveys';

/** Група модулів «Відносини» (RelationshipManagement): 4 модулів. */
export const relationshipManagementGroup: IModuleGroupManifest = {
  key: 'relationship-management',
  category: 'Relationship Management',
  name: { en: 'Relationship Management', uk: 'Відносини' },
  sort: 9,
  modules: [crmManifest, governmentManifest, governmentRelationsManifest, surveysManifest],
};
